var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAttration = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-turnover-5548757",
    transform: "translate(-20 -20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32505",
    "data-name": "Path 32505",
    d: "M29.927,22.538l-1.537.883h0l-1.976,1.144V22.574H22.579v5.857h-.587V21.991h4.417V20l1.976,1.144h0l1.981,1.139Zm6.715,4.82a6.568,6.568,0,1,0,0,9.289,6.571,6.571,0,0,0,0-9.289ZM32,29.1a1.634,1.634,0,1,0,1.634,1.634A1.632,1.632,0,0,0,32,29.1Zm-1.956,4.249a2.311,2.311,0,0,0-.7.531V34.9h5.326V33.879a2.311,2.311,0,0,0-.7-.531,2.224,2.224,0,0,0-.96-.214H31a2.318,2.318,0,0,0-.96.214Zm-1.277.214A2.9,2.9,0,0,1,30.6,32.521a2.274,2.274,0,1,1,2.809,0,2.88,2.88,0,0,1,1.828,1.042l.071.092v1.889H28.7V33.654Zm5.306,7.9,1.537-.889h0l1.976-1.144v1.991h3.835V35.564h.587v6.444H37.586V44L35.61,42.856h0l-1.976-1.139ZM22.538,34.073l.883,1.542h0L24.565,37.6H22.574v3.835h5.857v.577H21.991V37.586H20l1.144-1.981h0l1.139-1.971Zm18.924-4.146-.883-1.537h0l-1.144-1.976h1.991V22.579H35.564v-.587h6.444v4.417H44l-1.144,1.976h0l-1.139,1.981Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAttration, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Attration.d6163116.svg";
export { ForwardRef as ReactComponent };